<div class="flex flex-col" title="">
    <span class="body-header" [ngClass]="{ 'mb-10px': !subTitle }" [translate]="title"></span>
    @if (subTitle) {
        <span class="body-copy mb-10px" [translate]="subTitle"></span>
    }

    <!-- Primary user information -->
    @if (associatedUser) {
        <div class="flex flex-row">
            <div class="flex flex-col flex-1">
                <div class="flex justify-between flex-col md:flex-row">
                    <div class="flex flex-col mb-15px md:mb-0 flex-1">
                        <span class="label body-header" translate="userProfile.associatedUsers.name" title=""></span>
                        <span class="body-copy" title="">{{ associatedUser?.name | emptyField }}</span>
                    </div>
                    <div class="flex flex-col mb-15px md:mb-0 flex-1">
                        <span class="label body-header" translate="userProfile.associatedUsers.email" title=""></span>
                        <span class="body-copy" title="">{{ associatedUser?.email | emptyField }}</span>
                    </div>
                    <div class="flex flex-col mb-15px md:mb-0 flex-1">
                        <span
                            class="label body-header"
                            translate="userProfile.associatedUsers.mobilnummer"
                            title=""
                        ></span>
                        <span class="body-copy" title="">{{ formattedCellPhoneNumber | emptyField }}</span>
                    </div>
                    @if (associatedUser.isBusiness) {
                        <div class="flex flex-col mb-15px md:mb-0 flex-1">
                            <span
                                class="label body-header"
                                translate="userProfile.associatedUsers.phonenummer"
                                title=""
                            ></span>
                            <span class="body-copy" title="">{{ formattedPhoneNumber | emptyField }}</span>
                        </div>
                    }
                    <!-- Show CPR for private users -->
                    @if (!associatedUser.isBusiness) {
                        <div class="flex-col flex md:mb-0">
                            <div class="flex justify-start md:justify-end">
                                <span
                                    class="label body-header text-left md:text-right"
                                    translate="userProfile.associatedUsers.cpr"
                                    title=""
                                ></span>
                                <app-tooltip
                                    [text]="'userProfile.associatedUsers.cprTooltip' | translate"
                                ></app-tooltip>
                            </div>
                            <span class="contents body-copy w-180px text-right mr-30px md:text-left md:block">
                                @if (associatedUser?.birthDate) {
                                    <span class="text-left md:text-right" title=""
                                        >{{ associatedUser?.birthDate | date: 'ddMMyy' }}-xxxx</span
                                    >
                                }
                                @if (!associatedUser?.birthDate) {
                                    <span class="text-left" title="">-</span>
                                }
                            </span>
                        </div>
                    }
                    <!-- Show CVR for business users -->
                    @if (associatedUser.isBusiness) {
                        <div class="flex-col flex md:mb-0">
                            <div class="flex justify-start md:justify-end">
                                <span
                                    class="label body-header text-left md:text-right"
                                    translate="userProfile.associatedUsers.cvr"
                                    title=""
                                ></span>
                                <app-tooltip
                                    [text]="'userProfile.associatedUsers.cvrTooltip' | translate"
                                ></app-tooltip>
                            </div>
                            <span class="contents body-copy w-180px text-right mr-30px md:text-left md:block">
                                @if (associatedUser?.cvr) {
                                    <span class="text-left md:text-right" title="">{{ associatedUser?.cvr }}</span>
                                }
                                @if (!associatedUser?.cvr) {
                                    <span class="text-left" title="">-</span>
                                }
                            </span>
                        </div>
                    }
                </div>
            </div>
            <div class="flex flex-col cursor-pointer ml-30px md:justify-start">
                <mat-icon svgIcon="evida_edit" inline="true" (click)="editUserForm.emit(associatedUser)"></mat-icon>
            </div>
        </div>
    }

    <!-- Secondary user name -->
    @if (secondaryName) {
        <div class="flex flex-row">
            <div class="flex flex-col flex-1">
                <div class="flex flex-col mb-15px md:mb-0 flex-1">
                    <span class="label body-header" translate="userProfile.associatedUsers.name" title=""></span>
                    <span class="body-copy" title="">{{ secondaryName }}</span>
                </div>
            </div>
        </div>
    }
</div>

@if (divider) {
    <div class="divider"></div>
}
